import * as React from 'react';
import { useRef, useCallback } from 'react';
import MaterialTable from 'material-table';
import convertFirestoreDate from '../../utils/convertFirestoreDate';
import SalesCenterSetup from './setup/salesCenterSetup';
import SalesCenterDetailsPane from './detailsPane/salesCenterDetailsPane';

const BuilderSummaryTable = (props) => {
  const tableRef = useRef(null);
  const expandedRowsRef = useRef(new Set());

  const handleRowClick = useCallback((event, rowData, togglePanel) => {
    const key = rowData.builderId;
    if (expandedRowsRef.current.has(key)) {
      expandedRowsRef.current.delete(key);
    } else {
      expandedRowsRef.current.add(key);
    }
    togglePanel();
  }, []);

  // eslint-disable-next-line react/destructuring-assignment
  const dataWithExpanded = (props.salesCenterList || []).map((sc) => ({
    ...sc,
    tableData: {
      ...sc.tableData,
      showDetailPanel: expandedRowsRef.current.has(sc.builderId) ? 0 : undefined,
    },
  }));

  return (
    <div style={{ padding: 10, margin: 'auto', maxWidth: '100%' }}>
      <MaterialTable
        tableRef={tableRef}
        columns={
          [
            { title: 'Company Name', field: 'companyName' },
            { title: 'Sales Center Name', field: 'salescenterName' },
            { title: 'Builder ID', field: 'builderId' },
            {
              title: 'Branch',
              field: 'jenkinsBuild.branchName',
              render: (rowData) => rowData.jenkinsBuild?.branchName || '',
            },
            {
              title: 'Last Deployed',
              field: 'jenkinsBuild.date',
              render: (rowData) => {
                const date = rowData.jenkinsBuild?.date;
                return date ? convertFirestoreDate(date) : '';
              },
            },
            {
              title: 'Date Created',
              field: 'dateCreated',
              render: (rowData) => {
                const date = rowData.dateCreated;
                return date ? convertFirestoreDate(date) : '';
              },
            },
          ]
        }
        data={dataWithExpanded}
        actions={
          [
            {
              icon: 'launch',
              tooltip: 'Launch Web Site',
              onClick: (event, rowData) => window.open(rowData.websiteUrl, '_blank'),
            },
          ]
        }
        title="Summary of Builders"
        detailPanel={
          // eslint-disable-next-line react/no-unstable-nested-components
          (rowData) => {
            return (
              <div style={{ width: '100%', backgroundColor: 'aliceblue', padding: '10px' }}>
                {
                  rowData.status === 'COMPLETE'
                    // eslint-disable-next-line react/destructuring-assignment
                    ? <SalesCenterDetailsPane salesCenter={rowData} salesCenterList={props.salesCenterList} />
                    : <SalesCenterSetup salesCenter={rowData} />
                }
              </div>
            );
          }
        }
        options={
          {
            sorting: true,
            pageSize: 25,
            actionsColumnIndex: -1,
            rowStyle: (rowData) => ({
              backgroundColor: (rowData.status === 'SETUP') ? 'lightgreen' : '#FFFFFF',
            }),
          }
        }
        onRowClick={handleRowClick}
      />
    </div>
  );
};

export default BuilderSummaryTable;
